import React, {useState, useEffect} from 'react'
import supabase from '../../../supabaseClient';
import { Box, Select, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem } from '@mui/material'
import IdConfigurationGuard from '../../../Config/IdConfigurationGuard';


const pad = (n) => String(n).padStart(2, '0');
const toDateStr = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const parseLocal = (str) => { const [y, m, d] = str.split('-').map(Number); return new Date(y, m - 1, d); };

// One row per weekday (Mon–Fri) in [startDate, endDate], each worth a fixed 8h.
const buildWeekdayDates = (startDate, endDate) => {
    const dates = [];
    const cursor = parseLocal(startDate);
    const last = parseLocal(endDate);
    while (cursor <= last) {
        const dow = cursor.getDay(); // 0 = Sunday, 6 = Saturday
        if (dow !== 0 && dow !== 6) dates.push(toDateStr(cursor));
        cursor.setDate(cursor.getDate() + 1);
    }
    return dates;
};

function AttendanceAddAbsences({open, onClose,onRefresh,currentTime,idConfig}){
    const [employees,setEmployees]=useState([])
    const [selectedEmployee, setSelectedEmployee]=useState('')
    const [hourlyRate, setHourlyRate] = useState('')
    const [saving, setSaving] = useState(false)

    //current day
    const today =  new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth()+1).padStart(2,'0')
    const day = String(today.getDate()).padStart(2,'0')
    const currentDate = `${year}-${month}-${day}`

    //label date 'from'
    const [startDate, setStartDate] = useState(currentDate)

    //label date 'to'
    const [endDate, setEndDate] = useState(currentDate)

    //refreshing after close
    const handleClose = () => {
    setStartDate(currentDate);
    setEndDate(currentDate);
    setSelectedEmployee('');
    setHourlyRate('');
    onClose();
    onRefresh();
}

useEffect(()=>{
    if(!open) return;

    const fetchEmployees = async () => {
        const {data, error} = await supabase
        .from('employees')
        .select('id, name, surname, hourly_rate')
        .eq('id_configuration', idConfig )
        .is('archived', null)

        if(error){
            console.log(error)
        }else{setEmployees(data)}
    }
    fetchEmployees()
    }, [open]);

    const handleSelectEmployee = (id) => {
        setSelectedEmployee(id);
        const emp = employees.find(e => e.id === id);
        setHourlyRate(emp?.hourly_rate != null ? String(emp.hourly_rate * 8) : '');
    }

    const weekdayDates = buildWeekdayDates(startDate, endDate);

    const handleSave = async () => {
    if (weekdayDates.length === 0) {
        alert('Wybrany zakres nie zawiera żadnego dnia roboczego (pon.–pt.).');
        return;
    }

    setSaving(true);
    const { error } = await supabase
        .from('absences')
        .insert(weekdayDates.map(date => ({
            employee_id: selectedEmployee,
            id_configuration: idConfig,
            absence_start: date,
            absence_end: date,
            hours: 8,
            hourly_rate: hourlyRate === '' ? null : Number(hourlyRate) / 8,
        })));
    setSaving(false);

    if (error) { console.log('Błąd zapisu', error); alert('Błąd zapisu: ' + error.message); }
    else { handleClose(); }
}
    
    
return(
    <Box>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Dodaj urlop</DialogTitle>
                <DialogContent>
                    <Select
                        fullWidth
                        sx={{mt:2}}
                        value={selectedEmployee}
                        onChange={(e)=>handleSelectEmployee(e.target.value)}
                        displayEmpty
                        renderValue={(selected)=>{
                            if(!selected){
                                return <span style={{color: 'gray'}}> Wybierz pracownika </span>
                            }
                            const employee = employees.find(e => e.id === selected)
                            return employee ? `${employee.name} ${employee.surname}` : ''
                        }}
                    >
                      {employees.map(employee =>
                        <MenuItem key={employee.id} value={employee.id}>
                            {employee.name} {employee.surname}
                        </MenuItem>
                      )}
                    </Select>

                    <TextField
                        label='Dzień rozpoczęcia nieobecności'
                        fullWidth
                        type='date'
                        value={startDate}
                        sx={{mt:2}}
                        onChange={e=>setStartDate(e.target.value)}
                        onClick={e => e.target.showPicker?.()}
                    >

                    </TextField>

                    <TextField
                        label='Dzień zakończenia nieobecności'
                        fullWidth
                        type='date'
                        value={endDate}
                        sx={{mt:2}}
                        onChange={e=>setEndDate(e.target.value)}
                        onClick={e => e.target.showPicker?.()}
                    >
                    </TextField>

                    <TextField
                        label='Stawka dzienna urlopu (zł/dzień)'
                        fullWidth
                        type='number'
                        value={hourlyRate}
                        sx={{mt:2}}
                        onChange={e=>setHourlyRate(e.target.value)}
                        
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Anuluj</Button>
                    <Button
                        variant='contained'
                        disabled={!startDate || !endDate || !selectedEmployee || endDate < startDate || !hourlyRate || weekdayDates.length === 0 || saving}
                        onClick={handleSave}
                    >{saving ? 'Zapisywanie…' : 'Zapisz'}</Button>
                </DialogActions>

        </Dialog>

    </Box>
)}





export default AttendanceAddAbsences
